import { render, staticRenderFns } from "./CheckCustomer.vue?vue&type=template&id=7a8c5c12&scoped=true&"
import script from "./CheckCustomer.vue?vue&type=script&lang=js&"
export * from "./CheckCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8c5c12",
  null
  
)

export default component.exports